/**
 * @module app.shared
 */

import { autoinject } from "aurelia-framework";
import { EnvironmentService } from "../services/environment-service";

@autoinject
export class LogValueConverter {

    constructor(private readonly env: EnvironmentService) { }

    public toView(value: any, key?: any): any {
        if(this.env.config.debug) {
            if(key !== undefined && key !== null) {
                if(typeof key !== 'number' && typeof key !== 'string') {
                    key = `${key}`;
                }
                const result: any = {};
                result[key] = value;

                console.log(result);
            }
            else {
                console.log(value);
            }
        }

        return value;
    }

}

@autoinject
export class JsonValueConverter {

    constructor(private readonly env: EnvironmentService) { }

    public toView(value: any): string {
        if(this.env.config.debug) {
            try {
                return JSON.stringify(value, null, 4);
            }
            catch(error) {
                console.log({ jsonify: { error, value }});
            }
        }
        return '';
    }

}
